import { Pipe, PipeTransform } from '@angular/core';

// this was created to handle some timezone quirks in different browsers
// that don't play nice with "date:"
@Pipe({ name: 'slotsFormat' })
export class SlotsFormatPipe implements PipeTransform {
    constructor() {}

    transform(slotSet: any, show: any): any {
      if (show == "date") {
        let date = slotSet.date.getUTCDate();

        if (date < 10) {
          return "0" + date;
        }

        return date;
      } else if (show == "day") {
        return ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"][slotSet.date.getUTCDay()];
      } else {
        return "";
      }
    }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/Pipe/slots-format.pipe.ts